import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { isSupportedLanguage } from '../../../lib/i18n/language-config.ts';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';

/**
 * Headless consumer of the `?lng=` param that LanguageRedirect carries over
 * from the legacy /en and /de prefixes. The language itself is not touched —
 * it follows the user's stored preference / tenant default — the visit is
 * only reported, to measure whether such links are still in circulation.
 *
 * The param is consumed so reloads and copied URLs stay clean.
 */
export function LegacyLanguageUrl() {
    const [searchParams, setSearchParams] = useSearchParams();
    const sendEvent = useAnalytics();

    const urlLanguage = searchParams.get('lng');

    useEffect(() => {
        if (urlLanguage === null) {
            return;
        }

        setSearchParams(
            (previous) => {
                previous.delete('lng');
                return previous;
            },
            { replace: true },
        );

        if (!isSupportedLanguage(urlLanguage)) {
            return;
        }
        sendEvent('legacy_language_url_visited', {
            url_language: urlLanguage,
            path: window.location.pathname,
        });
    }, [urlLanguage, setSearchParams, sendEvent]);

    return null;
}
